import { capitalize } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import { INTERNAL_LINKS } from '../../../enum';
import { getMomentDateWithoutTimezone } from '../../../utils/datetime';
import { formatNumberWithCurrency } from '../../../utils/numbers';
import { CustomTable } from '../../index';
import LinkText from '../../Text/LinkText';

/**
 * A Table to display the Receipts data
 */
const MonthlyTaxReportReceiptsDetails = props => {
  const { t, dataSource, receiptsHidden, ...rest } = props;

  const COLUMNS = [
    {
      width: 50,
      title: t('ID'),
      dataIndex: 'seqId',
      key: 'seqId',
      render: (seqId, data) => (
        <Link
          to={`${receiptsHidden ? INTERNAL_LINKS.REIMBURSEMENT : INTERNAL_LINKS.RECEIPTS}/${
            data._id
          }`}
        >
          <LinkText variant="strong" size="sm">
            {seqId || 'Receipt'}
          </LinkText>
        </Link>
      ),
    },
    {
      width: 100,
      title: t('reimbursementPeriod'),
      dataIndex: 'period',
      key: 'period',
      render: period => {
        return getMomentDateWithoutTimezone(period.paymentPeriodStart).format('MMMM YYYY');
      },
    },
    {
      width: 100,
      title: t('type'),
      dataIndex: 'type',
      key: 'type',
      render: type => capitalize(type),
    },
    {
      width: 100,
      align: 'right',
      title: t('totalAmount'),
      dataIndex: 'totalAmount',
      key: 'amount',
      render: (actions, data) => {
        const adjustment = data.adjustment ? data.adjustment.amount : 0;

        return formatNumberWithCurrency(
          parseFloat(adjustment) + parseFloat(data.totalAmount) || 0,
          data.currency || 'USD',
        );
      },
    },
  ];

  return (
    <CustomTable
      showSearchInput={false}
      {...rest}
      onRow={row => ({
        leftBorderColor: row.hasCommuteDeduction ? 'danger' : '',
      })}
      dataSource={dataSource}
      rowKey={data => data._id}
      columns={COLUMNS}
      scroll={{ x: 970 }}
    />
  );
};

MonthlyTaxReportReceiptsDetails.defaultProps = {
  receiptsHidden: false,
};

MonthlyTaxReportReceiptsDetails.propTypes = {
  onApprove: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired,
  loggedInUserProfile: PropTypes.shape({}).isRequired,
  companyGroups: PropTypes.arrayOf(PropTypes.shape({})),
  receiptsHidden: PropTypes.bool,
};

export default MonthlyTaxReportReceiptsDetails;
